import Vue from 'vue'
import VueRouter from 'vue-router'
import ViewerPage from '../views/viewer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:service/:paper',
    name: 'InpockStoreDocumentViewer',
    props: true,
    component: ViewerPage
  },
  {
    path: '/:service/:paper/:type',
    name: 'InpockStoreDocumentViewer',
    props: true,
    component: ViewerPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
